import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import ShareholdersService from 'src/modules/3rd-party-management/apis/common/ShareholdersService';

export const SUPPLIER_OVERVIEW_SHAREHOLDERS_GRAPH_QUERY_KEY = '3rd-party-management-fetch-supplier-overview-shareholders-graph';

const useSupplierOverviewShareholdersGraph = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_SHAREHOLDERS_GRAPH_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = ShareholdersService.getInstance();

            return await service.fetchList(supplierId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching shareholders list.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewShareholdersGraph;
